<div class="center-95" #arrayContainer>
  <div class="array-parameters-button">
    <ng-container *ngIf="filterFields != null && filterFields.length > 0">
      <div style="float: left; padding-left: 10px">
        <mat-form-field style="width: calc(100% - 10px)">
          <input matInput (input)="filter($event, undefined)" placeholder="recherche globale" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </ng-container>
    <ng-container *ngIf="allowArrayCustomisation">
      <button mat-icon-button [ngClass]="'primary'" [matMenuTriggerFor]="menuArraySetting100">
        <mat-icon>settings</mat-icon>
      </button>
    </ng-container>
  </div>
  <div style="height: 100% ">
    <p-table
      #dt
      [value]="objectList"
      [(selection)]="objectListSelection"
      [columns]="columnsDefinition"
      [globalFilterFields]="filterFields"
      [reorderableColumns]="allowArrayCustomisation"
      [rows]="defaultRows"
      [showCurrentPageReport]="true"
      [autoLayout]="false"
      [loading]="loading"
      [paginator]="displayPaginator"
      [metaKeySelection]="true"
      [scrollable]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [columnResizeMode]="columnResizeMode"
      [scrollHeight]="ScrollableHeight"
      [paginatorStyleClass]="styleClassPaginator"
      [resizableColumns]="allowArrayCustomisation"
      selectionMode="multiple"
      [currentPageReportTemplate]="currentPageReportTemplate"
      [showFirstLastIcon]="false"
      sortMode="multiple"
      dataKey="id"
      (onColReorder)="columnsReorder($event)"
      scrollHeight="flex"
      (onColResize)="columnsResized($event)"
      (onRowUnselect)="checkBoxSelected()"
      (onRowSelect)="checkBoxSelected()"
      (onEditInit)="displayEditionField($event)"
      (onEditComplete)="editCellComplete($event)"
      [styleClass]="styleClass">
      <!-- dataKey="id" adding this generate bug for multiple selection, version bug ? || todo  [resizableColumns]="allowArrayCustomisation" with scale 0.75-->
      <ng-template pTemplate="paginatorright">
        <div *ngIf="loading == false" [class.display-none]="!displayPaginator" class="paginator">
          <!-- [class.paginator-with-variable-height]="heightMode == 'variable'"> -->
          <span>
            <button mat-icon-button (click)="setPage(currentPage - 1)" [disabled]="currentPage <= 1">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
          </span>
          <span style="line-height: 18px"
            >Aller à
            <input type="text" [ngModel]="currentPage" (ngModelChange)="setPage($event)" class="page-number-input" />
            / {{ numbersPages }}
          </span>
          <span>
            <button
              mat-icon-button
              (click)="setPage(currentPage + 1)"
              *ngIf="table && objectList && table.rows"
              [disabled]="currentPage == objectList.length / table.rows">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </span>
          <span class="paginator-counter" *ngIf="objectList?.length > 0 && table && table.first">
            {{ table.first + 1 }} à {{ lastItem }} sur {{ table.totalRecords }}
            <!-- Total : {{objectList.length}} Éléments -->
          </span>
          <span class="paginator-counter" *ngIf="objectList?.length == 0" style="color: white">
            0 éléments
            <!-- Total : {{objectList.length}} Éléments -->
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr [class.display-none]="!displayHeader">
          <ng-container *ngFor="let columnDefinition of columns">
            <ng-container [ngSwitch]="columnDefinition.type">
              <th *ngSwitchCase="'checkBox'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
                {{ columnDefinition.displayName }}
              </th>
              <th *ngSwitchCase="'icon'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn></th>
              <th *ngSwitchCase="'imgB64'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
                <div class="form-filter-container inline-display">
                  <span class="sort-icon-span">
                    <p-sortIcon [field]="columnDefinition.name" [pSortableColumn]="columnDefinition.name"></p-sortIcon>
                  </span>
                  <span style="opacity: 0.7">{{ columnDefinition.displayName }}</span>
                </div>
              </th>
              <th *ngSwitchCase="'edit'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn></th>
              <th *ngSwitchDefault [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
                <div class="form-filter-container inline-display">
                  <span class="sort-icon-span">
                    <p-sortIcon [field]="columnDefinition.name" [pSortableColumn]="columnDefinition.name"></p-sortIcon>
                  </span>
                  <!-- header name -->
                  <span class="form-filter-field">
                    <div class="inline-display">
                      <span
                        *ngIf="columnDefinition.readOnly == true && columnDefinition.drop == null; else notRO"
                        [class.form-filter-field]="
                          (columnDefinition.localFilter && columnDefinition.drop != null) ||
                          (columnDefinition.localFilter != null && columnDefinition.help != null)
                        "
                        class="inline-text-full-width"
                        matTooltip="Lecture seule"
                        [matTooltipClass]="toolTipsClass"
                        matTooltipPosition="above"
                        style="margin-left: 8px; color: grey">
                        {{ columnDefinition.displayName }}
                      </span>
                      <ng-template #notRO>
                        <span
                          [class.form-filter-field]="
                            (columnDefinition.localFilter && columnDefinition.drop != null) ||
                            (columnDefinition.localFilter && columnDefinition.readOnly == true && columnDefinition.drop == null) ||
                            (columnDefinition.localFilter != null && columnDefinition.help != null)
                          "
                          class="inline-text-full-width" style="margin-left: 8px; color: rgb(27, 27, 27)">
                          {{ columnDefinition.displayName }}
                        </span>
                      </ng-template>
                      <span style="display: contents" style="opacity: 0.7">
                        <ng-container *ngIf="columnDefinition.help != null">
                          <mat-icon
                            [matTooltip]="columnDefinition.help"
                            [matTooltipClass]="toolTipsClass"
                            matTooltipPosition="above"
                            class="header-help-tooltip-icon"
                            >help
                          </mat-icon>
                        </ng-container>
                        <ng-container *ngIf="columnDefinition.drop != null && columnDefinition.readOnly == false">
                          <!-- &nbsp;(<mat-icon>splitscreen</mat-icon>) -->
                          <mat-icon
                            [matTooltip]="'Glisser/déposer depuis le vivier \'' + columnDefinition.drop.dropName + '\''"
                            [matTooltipClass]="toolTipsClass"
                            matTooltipPosition="above"
                            class="header-help-tooltip-icon"
                            >help
                          </mat-icon>
                        </ng-container>
                      </span>
                    </div>
                  </span>
                  <!-- filter -->
                  <span *ngIf="columnDefinition.localFilter">
                    <span>
                      <button mat-icon-button [matMenuTriggerFor]="arrayFilter" class="small-mat-icon-button">
                        <mat-icon
                          class="array-filter-icon"
                          [class.activate-filtre]="filterList[columnDefinition.name] != null"
                          (click)="focusFilterInput(inputFilter)">
                          filter_alt
                        </mat-icon>
                      </button>
                    </span>
                    <mat-menu #arrayFilter="matMenu" class="prime-ng-d4-filter-menu">
                      <div class="array-filter-container" (click)="$event.stopPropagation()">
                        <mat-form-field class="form-field-without-underline">
                          <input
                            matInput
                            type="text"
                            (input)="filter($event, columnDefinition.name)"
                            placeholder="Rechercher"
                            appendTo="body"
                            #inputFilter />
                        </mat-form-field>
                      </div>
                    </mat-menu>
                    <!-- <mat-menu #menuArraySetting="matMenu" class="prime-ng-d4-parameter-wheel">
                      <div data-id="prime-ng-d4-filter">
                        <button mat-menu-item (click)="resetFilters()" [disabled]="ObjectKeys(filterList).length == 0">
                          <mat-icon>filter_alt_off</mat-icon>
                          <span>Supprimer les filtres</span>
                        </button>
                        <button mat-menu-item (click)="resetLocalConfiguration()">
                          <mat-icon>restart_alt</mat-icon>
                          <span>Réinitialiser les colonnes</span>
                        </button>
                      </div>
                    </mat-menu> -->
                  </span>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-object
        let-editing="editing"
        let-ri="rowIndex"
        class="droppable-item"
        let-rowIndex="rowIndex"
        let-columns="columns">
        <tr
          class="p-selectable-row p-fixed-height-table droppable-item"
          pDroppable="items"
          [pSelectableRow]="object"
          (mouseover)="handleMouseOver(object)"
          [ngStyle]="trNgStyle"
          [pSelectableRowIndex]="rowIndex"
          (mouseleave)="handleMouseLeave(object)"
          (keydown)="keyDownEventManagerRow($event, object)"
          (click)="handleRowClick($event, object)"
          (onDrop)="drop($event, object)"
          (onDragEnter)="dragEnter($event, ri)"
          [class.droppable-array-bg]="itemDragMvt"
          [class.drag-over]="itemDragMvt == true && dragRowOver == ri"
          [pReorderableRow]="ri">
          <ng-container *ngFor="let columnDefinition of columnsDefinition">
            <ng-container [ngSwitch]="columnDefinition.type">
              <td
                *ngSwitchCase="'icon'"
                [ngClass]="columnDefinition.ngClass"
                (mouseover)="handleMouseOver(object)"
                (mouseleave)="handleMouseLeave(object)"
                (click)="objectAction(object, columnDefinition.name)"
                [ngStyle]="columnDefinition.ngStyle"
                style="cursor : pointer !important">
                <mat-icon class="mat-icon-in-D4-row" *ngIf="columnDefinition.help == null">{{ columnDefinition.displayName }}</mat-icon>
                <mat-icon
                  class="mat-icon-in-D4-row"
                  *ngIf="columnDefinition.help != null"
                  [matTooltip]="columnDefinition.help"
                  [matTooltipClass]="toolTipsClass"
                  matTooltipPosition="below"
                  matTooltipShowDelay="350">
                  {{ columnDefinition.displayName }}</mat-icon
                >
              </td>
              <td
                *ngSwitchCase="'edit'"
                (mouseover)="handleMouseOver(object)"
                (mouseleave)="handleMouseLeave(object)"
                (click)="editObject(object); editCellInit(object, $event)"
                style="cursor : pointer !important"
                [ngStyle]="columnDefinition.ngStyle">
                <mat-icon *ngIf="columnDefinition.help == null">edit</mat-icon>
                <mat-icon
                  *ngIf="columnDefinition.help != null"
                  [matTooltip]="columnDefinition.help"
                  [matTooltipClass]="toolTipsClass"
                  matTooltipPosition="below"
                  matTooltipShowDelay="350">
                  edit</mat-icon
                >
              </td>
              <td *ngSwitchCase="'imgB64'" [ngStyle]="columnDefinition.ngStyle" (click)="objectAction(object, columnDefinition.name)">
                <img [src]="getImgB64(columnDefinition.name, object)" />
              </td>

              <!--
                ---------- read/write row------------
                -->
              <ng-container *ngIf="columnDefinition.readOnly == false && object != null">
                <td *ngSwitchCase="'checkBox'" [ngStyle]="columnDefinition.ngStyle" >
                  <p-tableCheckbox [value]="object" (click)="checkBoxSelected()"> </p-tableCheckbox>
                </td>
                <td *ngSwitchCase="'booleanCheckBox'" [ngStyle]="columnDefinition.ngStyle">
                  <mat-checkbox
                    class="user-selection"
                    [ngModel]="getObject(columnDefinition.name, object)"
                    [disabled]="object?.readOnly == true"
                    [class.display-none]="
                      getObject(columnDefinition.name, object) != true && getObject(columnDefinition.name, object) != false
                    "
                    (change)="outputValue(columnDefinition.name, object, $event)"></mat-checkbox>
                </td>
                <td *ngSwitchCase="'booleanCheckBoxSwitch'" [ngStyle]="columnDefinition.ngStyle">
                  <mat-slide-toggle
                    class="user-selection mat-slide-toggle" 
                    [ngModel]="getObject(columnDefinition.name, object)"
                    [disabled]="object?.readOnly == true" [class.display-none]="
                    getObject(columnDefinition.name, object) != true && getObject(columnDefinition.name, object) != false
                    " 
                    (toggleChange)="outputValue(columnDefinition.name, object, 'toggleChange')"></mat-slide-toggle>
                </td>
                <td
                  *ngSwitchCase="'textArea'"
                  class="cursor-default text-area-type"
                  [ngStyle]="columnDefinition.ngStyle"
                  [class.no-ellipsis]="columnDefinition.printLine != null">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!--standard value-->
                  <ng-container
                    *ngIf="
                      (columnDefinition.helpValue == undefined || columnDefinition.helpValue == false) &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    ">
                    <span>
                      <button
                        mat-icon-button
                        [disabled]="object?.readOnly == true"
                        class="small-mat-icon-button"
                        (click)="displayTextArea(columnDefinition.name, object, true)">
                        <mat-icon>edit_note</mat-icon>
                      </button>
                    </span>
                    <span class="image-text cursor-default">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                  </ng-container>
                  <!-- value with tooltip -->
                  <ng-container
                    *ngIf="
                      columnDefinition.helpValue != undefined &&
                      columnDefinition.helpValue == true &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    ">
                    <span
                      class="image-text cursor-default"
                      [matTooltip]="getObjectToolTip(columnDefinition.name, ri)"
                      [matTooltipClass]="toolTipsClass"
                      matTooltipPosition="below"
                      matTooltipShowDelay="500">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <span>
                      <button
                        mat-icon-button
                        [disabled]="object?.readOnly == true"
                        class="small-mat-icon-button"
                        (click)="displayTextArea(columnDefinition.name, object, true)">
                        <mat-icon>edit_note</mat-icon>
                      </button>
                    </span>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'string'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <ng-container *ngIf="columnDefinition.printLine == null">
                    <p-cellEditor>
                      <ng-template pTemplate="input">
                        <mat-form-field style="top: 9px; width: 100%" appearance="outline">
                          <input
                            matInput
                            [ngModel]="getObject(columnDefinition.name, object)"
                            (focus)="editCellInit(object, $event)"
                            [disabled]="object?.readOnly == true"
                            (change)="inputChange(columnDefinition.name, object, $event.currentTarget)" />
                        </mat-form-field>
                      </ng-template>
                      <ng-template pTemplate="output">
                        {{ getObject(columnDefinition.name, object) }}
                      </ng-template>
                    </p-cellEditor>
                  </ng-container>
                  <div style="position: absolute">
                    <p-cellEditor>
                      <ng-container *ngIf="columnDefinition.popUpComponent != null">
                        <!-- <div class="setting-btn-in-array"> -->
                        <button
                          mat-icon-button
                          (click)="showPopUp(columnDefinition.popUpComponent, object, $event)"
                          class="small-mat-icon-button"
                          [matTooltipClass]="toolTipsClass"
                          matTooltipPosition="below"
                          matTooltipShowDelay="350"
                          matTooltip="paramétrage">
                          <mat-icon>settings</mat-icon>
                        </button>
                        <!-- </div> -->
                      </ng-container>
                      <ng-container *ngIf="columnDefinition.printLine != null">
                        <ng-template pTemplate="input">
                          <mat-form-field style="top: 9px" appearance="outline">
                            <input
                              matInput
                              [ngModel]="callmethode(columnDefinition.printLine, object).topLine"
                              (focus)="editCellInit(object, $event)"
                              [disabled]="object?.readOnly == true"
                              (change)="writeLine(columnDefinition.writeLine, columnDefinition.name, object, $event.currentTarget)" />
                          </mat-form-field>
                        </ng-template>
                        <ng-template pTemplate="output">
                          <ng-container *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == ''; else twoLinesRow">
                            <div
                              style="display: contents"
                              class="image-text cursor-default"
                              [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                          </ng-container>
                          <ng-template #twoLinesRow>
                            <div style="display: inline-grid; vertical-align: middle; margin-top: -10px">
                              <span
                                class="image-text cursor-default"
                                [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></span>
                              <span
                                class="image-text cursor-default"
                                [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe: 'html'"
                                style="font-size: 0.8em"></span>
                            </div>
                          </ng-template>
                        </ng-template>
                      </ng-container>
                    </p-cellEditor>
                  </div>
                </td>
                <td
                  *ngSwitchCase="'link'"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [class.no-ellipsis]="columnDefinition.printLine != null">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!-- popup configuration button -->
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px; width: 100%" appearance="outline" class="string-as-link-rw-input">
                        <input
                          matInput
                          [ngModel]="getObject(columnDefinition.name, object)"
                          (focus)="editCellInit(object, $event)"
                          [disabled]="object?.readOnly == true"
                          (change)="inputChange(columnDefinition.name, object, $event.currentTarget)" />
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <!-- display help over -->
                      <span
                        class="image-text cursor-default string-as-link-rw"
                        *ngIf="
                          (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) && columnDefinition.printLine == null
                        ">
                        {{ getObject(columnDefinition.name, object) }}
                      </span>

                      <!-- specific print line -->
                      <ng-container *ngIf="columnDefinition.printLine != null">
                        <ng-container *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == ''; else twoLinesRow">
                          <div
                            style="display: contents"
                            class="image-text cursor-default"
                            [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                        </ng-container>
                        <ng-template #twoLinesRow>
                          <span style="display: inline-grid; vertical-align: middle; margin-top: -10px">
                            <div
                              class="image-text cursor-default"
                              [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                            <div
                              class="image-text cursor-default"
                              style="font-size: 0.8em"
                              [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe: 'html'"></div>
                          </span>
                        </ng-template>
                      </ng-container>
                      <!-- copy btn -->
                      <ng-container *ngIf="columnDefinition.copyBtn">
                        <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-rw">
                          {{ getObject(columnDefinition.name, object) }}
                        </span>
                        <div class="copy-btn-in-array">
                          <button
                            mat-icon-button
                            ngxClipboard
                            [cbContent]="getObject(columnDefinition.name, object)"
                            (click)="clipBoardContentInfo()"
                            [ngClass]="'primary'"
                            class="small-mat-icon-button">
                            <mat-icon
                              matTooltip="copier le contenu"
                              matTooltipClass="tool-tip-size-0-7-em"
                              matTooltipPosition="below"
                              matTooltipShowDelay="400">
                              content_copy</mat-icon
                            >
                          </button>
                        </div>
                      </ng-container>
                    </ng-template>
                  </p-cellEditor>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button (click)="downloadLink(object, columnDefinition.name, $event)" class="small-mat-icon-button">
                      <mat-icon
                        matTooltip="copier le contenu"
                        matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below"
                        matTooltipShowDelay="400">
                        open_in_new</mat-icon
                      >
                    </button>
                  </div>
                </td>
                <td
                  *ngSwitchCase="'mail'"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [class.no-ellipsis]="columnDefinition.printLine != null">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!-- popup configuration button -->
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px; width: 100%" appearance="outline" class="string-as-link-rw-input">
                        <input
                          matInput
                          [ngModel]="getObject(columnDefinition.name, object)"
                          (focus)="editCellInit(object, $event)"
                          [disabled]="object?.readOnly == true"
                          (change)="inputChange(columnDefinition.name, object, $event.currentTarget)" />
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <!-- display help over -->
                      <span
                        class="image-text cursor-default string-as-link-rw"
                        *ngIf="
                          (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) && columnDefinition.printLine == null
                        ">
                        {{ getObject(columnDefinition.name, object) }}
                      </span>

                      <!-- specific print line -->
                      <ng-container *ngIf="columnDefinition.printLine != null">
                        <ng-container *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == ''; else twoLinesRow">
                          <div
                            style="display: contents"
                            class="image-text cursor-default"
                            [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                        </ng-container>
                        <ng-template #twoLinesRow>
                          <span style="display: inline-grid; vertical-align: middle; margin-top: -10px">
                            <div
                              class="image-text cursor-default"
                              [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                            <div
                              class="image-text cursor-default"
                              style="font-size: 0.8em"
                              [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe: 'html'"></div>
                          </span>
                        </ng-template>
                      </ng-container>
                      <!-- copy btn -->
                      <ng-container *ngIf="columnDefinition.copyBtn">
                        <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-rw">
                          {{ getObject(columnDefinition.name, object) }}
                        </span>
                        <div class="copy-btn-in-array">
                          <button
                            mat-icon-button
                            ngxClipboard
                            [cbContent]="getObject(columnDefinition.name, object)"
                            [ngClass]="'primary'"
                            (click)="clipBoardContentInfo()"
                            class="small-mat-icon-button">
                            <mat-icon
                              matTooltip="copier le contenu"
                              matTooltipClass="tool-tip-size-0-7-em"
                              matTooltipPosition="below"
                              matTooltipShowDelay="400">
                              content_copy</mat-icon
                            >
                          </button>
                        </div>
                      </ng-container>
                    </ng-template>
                  </p-cellEditor>
                  <div class="copy-btn-in-array">
                    <a
                      mat-icon-button
                      *ngIf="getObject(columnDefinition.name, object).length > 8"
                      matTooltip="E-mail"
                      class="small-mat-icon-button"
                      [href]="'mailto:' + getObject(columnDefinition.name, object)">
                      <mat-icon>mail</mat-icon></a
                    >
                  </div>
                </td>
                <td
                  *ngSwitchCase="'number'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px" appearance="outline">
                        <input
                          matInput
                          [ngModel]="getObject(columnDefinition.name, object)"
                          (focus)="editCellInit(object, $event)"
                          [disabled]="object?.readOnly == true"
                          (change)="inputChange(columnDefinition.name, object, $event.currentTarget)"
                          type="number" />
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getObject(columnDefinition.name, object) }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'decimal'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px" appearance="outline">
                        <input
                          matInput
                          [ngModel]="getObject(columnDefinition.name, object)"
                          [disabled]="object?.readOnly == true"
                          (change)="inputChange(columnDefinition.name, object, $event.currentTarget)"
                          (focus)="editCellInit(object, $event)"
                          type="number" />
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getObject(columnDefinition.name, object) | number: "1.2-2" }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'currency'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px" appearance="outline">
                        <input
                          matInput
                          [ngModel]="getObject(columnDefinition.name, object)"
                          [disabled]="object?.readOnly == true"
                          (focus)="editCellInit(object, $event)"
                          type="currency" />
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getObject(columnDefinition.name, object) | currency: "EUR" }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'phone'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}></span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <div>
                        <ngx-intl-tel-input
                          [preferredCountries]="preferredCountries"
                          [enableAutoCountrySelect]="true"
                          [enablePlaceholder]="true"
                          [searchCountryFlag]="true"
                          [selectFirstCountry]="false"
                          #intPhoneControl
                          [maxLength]="15"
                          [phoneValidation]="true"
                          [separateDialCode]="false"
                          (ngxTelOutput)="setPhoneNumber($event, columnDefinition.name, object)"
                          [ngModel]="getObject(columnDefinition.name, object)">
                        </ngx-intl-tel-input>
                      </div>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getObject(columnDefinition.name, object) }}
                      <a
                        mat-icon-button
                        *ngIf="getObject(columnDefinition.name, object).length > 8"
                        matTooltip="Contacter"
                        [href]="'tel:' + getObject(columnDefinition.name, object)">
                        <mat-icon>phone</mat-icon></a
                      >
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'date'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">date-mat-form</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px" appearance="outline">
                        <input
                          matInput
                          [matDatepicker]="picker1"
                          [ngModel]="getObject(columnDefinition.name, object)"
                          #refDate
                          (focus)="editCellInit(object, $event)"
                          [disabled]="object?.readOnly == true"
                          (dateChange)="inputDateChange(columnDefinition.name, object, $event)"
                          (change)="inputDateChangeKeyBoardInput(columnDefinition.name, object, $event)" />
                        <mat-datepicker-toggle matSuffix [for]="picker1" [disabled]="object?.readOnly == true"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getObject(columnDefinition.name, object) | date: "shortDate" }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'dateTime'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">date-time-mat-form</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field style="top: 9px" appearance="outline">
                        <input
                          matInput
                          [ngxMatDatetimePicker]="pickerTime"
                          (focus)="editCellInit(object, $event)"
                          [ngModel]="getObject(columnDefinition.name, object)"
                          [disabled]="object?.readOnly == true"
                          (dateChange)="inputDateChange(columnDefinition.name, object, $event)"
                          (change)="inputDateChangeKeyBoardInput(columnDefinition.name, object, $event)" />
                        <button
                          mat-icon-button
                          matSuffix
                          (click)="pickerTime.open(); $event.stopPropagation()"
                          class="small-mat-icon-button">
                          <mat-icon>today</mat-icon>
                        </button>
                        <ngx-mat-datetime-picker #pickerTime [ngClass]="'primary'" [showSeconds]="false" [disabled]="object?.readOnly == true">
                          <ngx-mat-datepicker-actions>
                            <button mat-icon-button ngxMatDatepickerCancel>
                              <mat-icon>close</mat-icon>
                            </button>
                            <button mat-icon-button ngxMatDatepickerApply>
                              <mat-icon>done</mat-icon>
                            </button>
                          </ngx-mat-datepicker-actions>
                        </ngx-mat-datetime-picker>
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      {{ getObject(columnDefinition.name, object) | date: "dd LLL yyyy à HH:mm" }}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'duration'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">duration-mat-form</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input" *ngIf="object?.readOnly != true">
                      <app-overlay-duration-picker
                        [initialValue]="getObject(columnDefinition.name, object)"
                        (outputValue)="outputValue(columnDefinition.name, object, $event)"
                        [autoOpen]="true">
                      </app-overlay-duration-picker>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <app-overlay-duration-picker
                        [initialValue]="getObject(columnDefinition.name, object)"
                        (outputValue)="outputValue(columnDefinition.name, object, $event)"
                        [autoOpen]="false">
                      </app-overlay-duration-picker>
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'enum'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field
                        style="top: 9px; width: 90%"
                        #matSelectForms
                        class="mat-mdc-text-field-wrapper-small"
                        id="{{ 'prime-ng-d4-enum-' + columnDefinition.name + '-' + ri }}"
                        appearance="outline">
                        <mat-select
                          [value]="getObject(columnDefinition.name, object)"
                          (selectionChange)="setEnum(object, $event, columnDefinition.name)"
                          class="mat-mdc-text-field-wrapper-small"
                          (openedChange)="editCellInit(object, $event)"
                          [disabled]="object?.readOnly == true">
                          <mat-option *ngFor="let enum of columnDefinition.enum" [value]="enum.value">
                            <span id="{{ enum.displayValue }}" style="display: none"></span>{{ enum.displayValue }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <mat-form-field
                        style="top: 9px; width: 90%"
                        class="mat-mdc-text-field-wrapper-small"
                        id="{{ 'prime-ng-d4-enum-' + columnDefinition.name + '-' + ri }}"
                        appearance="outline">
                        <mat-select
                          [value]="getObject(columnDefinition.name, object)"
                          disabled="true"
                          class="mat-mdc-text-field-wrapper-small">
                          <mat-option *ngFor="let enum of columnDefinition.enum" [value]="enum.value">
                            {{ enum.displayValue }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td
                  *ngSwitchCase="'booleanDropDown'"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <mat-form-field
                        style="top: 9px; width: 90%"
                        #matSelectForms
                        class="mat-mdc-text-field-wrapper-small"
                        id="{{ 'prime-ng-d4-enum-' + columnDefinition.name + '-' + ri }}"
                        appearance="outline">
                        <mat-select
                          [value]="getObject(columnDefinition.name, object)"
                          class="mat-mdc-text-field-wrapper-small"
                          [disabled]="object?.readOnly == true"
                          (openedChange)="editCellInit(object, $event)"
                          (selectionChange)="setEnum(object, $event, columnDefinition.name)">
                          <mat-option [value]="true">Oui</mat-option>
                          <mat-option [value]="false">Non</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <mat-form-field style="top: 9px; width: 90%" appearance="outline" class="mat-mdc-text-field-wrapper-small">
                        <mat-select
                          [value]="getObject(columnDefinition.name, object)"
                          disabled="true"
                          class="mat-mdc-text-field-wrapper-small">
                          <mat-option [value]="true">Oui</mat-option>
                          <mat-option [value]="false">Non</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </ng-template>
                  </p-cellEditor>
                </td>
              </ng-container>
              <!--
                ---------- read only row------------
                -->
              <ng-container *ngIf="columnDefinition.readOnly == true">
                <td
                  *ngSwitchCase="'checkBox'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  [ngStyle]="columnDefinition.ngStyle"
                  class="mat-checkbox-in-D4-row">
                  <p-tableCheckbox [value]="object" [disabled]="true" style="display: contents"></p-tableCheckbox>
                </td>
                <td *ngSwitchCase="'booleanCheckBox'" (dblclick)="displayROSnackBar(columnDefinition)" [ngStyle]="columnDefinition.ngStyle">
                  <mat-checkbox
                    class="user-selection"
                    [ngModel]="getObject(columnDefinition.name, object)"
                    [class.display-none]="
                      getObject(columnDefinition.name, object) != true && getObject(columnDefinition.name, object) != false
                    "
                    [disabled]="true"
                    [class.disabled-mat-checkbox-checked-bg-color-force]="getObject(columnDefinition.name, object) == true"></mat-checkbox>
                </td>
                <td
                  *ngSwitchCase="'textArea'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default text-area-type"
                  [ngStyle]="columnDefinition.ngStyle"
                  [class.no-ellipsis]="columnDefinition.printLine != null">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!--standard value-->
                  <ng-container
                    *ngIf="
                      (columnDefinition.helpValue == undefined || columnDefinition.helpValue == false) &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    ">
                    <span>
                      <button mat-icon-button class="small-mat-icon-button" (click)="displayTextArea(columnDefinition.name, object, false)">
                        <mat-icon>expand_content</mat-icon>
                      </button>
                    </span>
                    <span class="image-text cursor-default">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                  </ng-container>
                  <!-- value with tooltip -->
                  <ng-container
                    *ngIf="
                      columnDefinition.helpValue != undefined &&
                      columnDefinition.helpValue == true &&
                      (columnDefinition.copyBtn == undefined || columnDefinition?.copyBtn == false)
                    ">
                    <span
                      class="image-text cursor-default"
                      [matTooltip]="getObjectToolTip(columnDefinition.name, ri)"
                      [matTooltipClass]="toolTipsClass"
                      matTooltipPosition="below"
                      matTooltipShowDelay="500">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <span>
                      <button mat-icon-button class="small-mat-icon-button" (click)="displayTextArea(columnDefinition.name, object, false)">
                        <mat-icon>expand_content</mat-icon>
                      </button>
                    </span>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'string'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default read-only-td"
                  [ngStyle]="columnDefinition.ngStyle"
                  [class.no-ellipsis]="columnDefinition.printLine != null">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!-- popup configuration button -->
                  <div>
                    <span>
                      <ng-container *ngIf="columnDefinition.popUpComponent != null">
                        <div class="setting-btn-in-array">
                          <button
                            mat-icon-button
                            (click)="showPopUp(columnDefinition.popUpComponent, object, $event)"
                            class="small-mat-icon-button"
                            [matTooltipClass]="toolTipsClass"
                            matTooltipPosition="below"
                            matTooltipShowDelay="350"
                            matTooltip="paramétrage">
                            <mat-icon>settings</mat-icon>
                          </button>
                        </div>
                      </ng-container>
                    </span>
                    <!--standard value-->
                    <span
                      class="image-text cursor-default"
                      *ngIf="
                        (columnDefinition.helpValue == undefined || columnDefinition.helpValue == false) &&
                        (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) &&
                        columnDefinition.printLine == null
                      ">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <!-- value with tooltip -->
                    <span
                      class="image-text cursor-default"
                      *ngIf="
                        columnDefinition.helpValue != undefined &&
                        columnDefinition.helpValue == true &&
                        (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) &&
                        columnDefinition.printLine == null
                      "
                      [matTooltip]="getObjectToolTip(columnDefinition.name, ri)"
                      [matTooltipClass]="toolTipsClass"
                      matTooltipPosition="below"
                      matTooltipShowDelay="500">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <!-- value generated with methode  -->
                    <ng-container *ngIf="columnDefinition.printLine != null">
                      <ng-container *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == ''; else twoLinesRow">
                        <div
                          style="display: contents"
                          class="image-text cursor-default"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                      </ng-container>
                      <ng-template #twoLinesRow>
                        <div style="display: inline-grid; vertical-align: middle; margin-top: -10px">
                          <div
                            class="image-text cursor-default"
                            [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                          <div
                            class="image-text cursor-default"
                            style="font-size: 0.8em"
                            [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe: 'html'"></div>
                        </div>
                      </ng-template>
                    </ng-container>
                    <!-- value with copie/past -->
                    <ng-container *ngIf="columnDefinition.copyBtn">
                      <span class="image-text cursor-default text-ro-with-copy-btn">
                        {{ getObject(columnDefinition.name, object) }}
                      </span>
                      <div class="copy-btn-in-array">
                        <button
                          mat-icon-button
                          ngxClipboard
                          [cbContent]="getObject(columnDefinition.name, object)"
                          [ngClass]="'primary'"
                          (click)="clipBoardContentInfo()"
                          class="small-mat-icon-button">
                          <mat-icon
                            matTooltip="copier le contenu"
                            matTooltipClass="tool-tip-size-0-7-em"
                            matTooltipPosition="below"
                            matTooltipShowDelay="400">
                            content_copy</mat-icon
                          >
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </td>
                <td
                  *ngSwitchCase="'link'"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  [class.no-ellipsis]="columnDefinition.printLine != null"
                  (click)="downloadLink(object, columnDefinition.name, $event)">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!-- popup configuration button -->

                  <!-- display help over -->
                  <span
                    class="image-text cursor-default string-as-link-ro"
                    *ngIf="
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) && columnDefinition.printLine == null
                    ">
                    {{ getObject(columnDefinition.name, object) }}
                  </span>

                  <!-- specific print line -->
                  <ng-container *ngIf="columnDefinition.printLine != null">
                    <ng-container *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == ''; else twoLinesRow">
                      <div
                        style="display: contents"
                        class="image-text cursor-default"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                    </ng-container>
                    <ng-template #twoLinesRow>
                      <span style="display: inline-grid; vertical-align: middle; margin-top: -10px">
                        <div
                          class="image-text cursor-default"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                        <div
                          class="image-text cursor-default"
                          style="font-size: 0.8em"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe: 'html'"></div>
                      </span>
                    </ng-template>
                  </ng-container>
                  <!-- copy btn -->
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        [cbContent]="getObject(columnDefinition.name, object)"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()"
                        class="small-mat-icon-button">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'number'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <!--standard value-->
                  <span
                    class="image-text cursor-default"
                    *ngIf="
                      (columnDefinition.helpValue == undefined || columnDefinition.helpValue == false) &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    ">
                    {{ getObject(columnDefinition.name, object) | number }}
                  </span>
                  <!-- value with tooltip -->
                  <span
                    class="image-text cursor-default"
                    *ngIf="
                      columnDefinition.helpValue != undefined &&
                      columnDefinition.helpValue == true &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    "
                    [matTooltip]="getObjectToolTip(columnDefinition.name, ri)"
                    [matTooltipClass]="toolTipsClass"
                    matTooltipPosition="below"
                    matTooltipShowDelay="500">
                    {{ getObject(columnDefinition.name, object) | number }}
                  </span>
                  <!-- value with copie/past -->
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn">
                      {{ getObject(columnDefinition.name, object) | number }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        [cbContent]="(getObject(columnDefinition.name, object) | number) || undefined"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()"
                        class="small-mat-icon-button">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'decimal'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <!--standard value-->
                  <span
                    class="image-text cursor-default"
                    *ngIf="
                      (columnDefinition.helpValue == undefined || columnDefinition.helpValue == false) &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    ">
                    {{ getObject(columnDefinition.name, object) | number: "1.2-2" }}
                  </span>
                  <!-- value with tooltip -->
                  <span
                    class="image-text cursor-default"
                    *ngIf="
                      columnDefinition.helpValue != undefined &&
                      columnDefinition.helpValue == true &&
                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)
                    "
                    [matTooltip]="getObjectToolTip(columnDefinition.name, ri)"
                    [matTooltipClass]="toolTipsClass"
                    matTooltipPosition="below"
                    matTooltipShowDelay="500">
                    {{ getObject(columnDefinition.name, object) | number: "1.2-2" }}
                  </span>
                  <!-- value with copie/past -->
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn">
                      {{ getObject(columnDefinition.name, object) | number: "1.2-2" }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        class="small-mat-icon-button"
                        [cbContent]="(getObject(columnDefinition.name, object) | number: '1.2-2') || undefined"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'currency'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <span
                    class="image-text cursor-default"
                    *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                    {{ getObject(columnDefinition.name, object) | currency: "EUR" }}
                  </span>
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn">
                      {{ getObject(columnDefinition.name, object) | currency: "EUR" }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        class="small-mat-icon-button"
                        [cbContent]="(getObject(columnDefinition.name, object) | currency: 'EUR') || undefined"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'phone'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle"
                  (click)="phoneLink(object, columnDefinition.name, $event)">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <span
                    class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro"
                    *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                    {{ getObject(columnDefinition.name, object) }}
                    <!-- <div class="copy-btn-in-array">
                      <a mat-icon-button *ngIf="getObject(columnDefinition.name, object).length > 8"
                        matTooltip="Contacter" class="small-mat-icon-button"
                        [href]="'tel:'+getObject(columnDefinition.name, object)">
                        <mat-icon>phone</mat-icon></a>
                    </div> -->
                  </span>
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        [cbContent]="getObject(columnDefinition.name, object)"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()"
                        class="small-mat-icon-button">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'mail'"
                  (click)="mailLink(object, columnDefinition.name, $event)"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <span
                    class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro"
                    *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                    {{ getObject(columnDefinition.name, object) }}
                  </span>
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro">
                      {{ getObject(columnDefinition.name, object) }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        [cbContent]="getObject(columnDefinition.name, object)"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()"
                        class="small-mat-icon-button">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'date'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <span
                    class="image-text cursor-default"
                    *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                    {{ getObject(columnDefinition.name, object) | date: "shortDate" }}
                  </span>
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn">
                      {{ getObject(columnDefinition.name, object) | date }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        [cbContent]="(getObject(columnDefinition.name, object) | date: 'shortDate') || undefined"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()"
                        class="small-mat-icon-button">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'dateTime'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <span
                    class="image-text cursor-default"
                    *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                    {{ getObject(columnDefinition.name, object) | date: "dd LLL yyyy à HH:mm" }}
                  </span>
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn">
                      {{ getObject(columnDefinition.name, object) | date: "dd LLL yyyy à HH:mm" }}
                    </span>
                    <div class="copy-btn-in-array">
                      <button
                        mat-icon-button
                        ngxClipboard
                        [cbContent]="(getObject(columnDefinition.name, object) | date: 'dd LLL yyyy à HH:mm') || undefined"
                        [ngClass]="'primary'"
                        (click)="clipBoardContentInfo()"
                        class="small-mat-icon-button">
                        <mat-icon
                          matTooltip="copier le contenu"
                          matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below"
                          matTooltipShowDelay="400">
                          content_copy</mat-icon
                        >
                      </button>
                    </div>
                  </ng-container>
                </td>
                <td
                  *ngSwitchCase="'enum'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <mat-form-field style="top: 9px; width: 90%" class="cursor-default" class="mat-mdc-text-field-wrapper-small">
                    <mat-select
                      [value]="getObject(columnDefinition.name, object)"
                      data-id="prime-ng-d4-enum"
                      class="mat-mdc-text-field-wrapper-small"
                      [disabled]="true">
                      <mat-option *ngFor="let enum of columnDefinition.enum" [value]="enum.value">
                        {{ enum.displayValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
                <td
                  *ngSwitchCase="'booleanDropDown'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  class="cursor-default"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">{{ columnDefinition.displayName }}</span>
                  <mat-form-field style="top: 9px; width: 90%" class="cursor-default" class="mat-mdc-text-field-wrapper-small">
                    <mat-select
                      [value]="getObject(columnDefinition.name, object)"
                      class="mat-mdc-text-field-wrapper-small"
                      [disabled]="true">
                      <mat-option [value]="true">Oui</mat-option>
                      <mat-option [value]="false">Non</mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
                <td
                  *ngSwitchCase="'duration'"
                  (dblclick)="displayROSnackBar(columnDefinition)"
                  [pEditableColumn]="object"
                  [pEditableColumnField]="columnDefinition.name"
                  [ngStyle]="columnDefinition.ngStyle">
                  <span class="p-column-title" id="{{ 'colIndex' + arrayGuid + ri }}">duration-mat-form</span>
                  <ng-container *ngIf="columnDefinition.printLine != null">
                    <ng-container *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == ''; else twoLinesRow">
                      <div
                        style="display: contents"
                        class="image-text cursor-default"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></div>
                    </ng-container>
                    <ng-template #twoLinesRow>
                      <div style="display: inline-grid; vertical-align: middle; margin-top: -10px">
                        <span
                          class="image-text cursor-default"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe: 'html'"></span>
                        <span
                          class="image-text cursor-default"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe: 'html'"
                          style="font-size: 0.8em"></span>
                      </div>
                    </ng-template>
                  </ng-container>
                  <ng-container *ngIf="columnDefinition.printLine == null">
                    {{ getObject(columnDefinition.name, object) }}
                  </ng-container>
                </td>
              </ng-container>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="empty-td-message">
            {{ nullArrayDisplayText }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<mat-menu #menuArraySetting100="matMenu">
  <div>
    <button mat-menu-item (click)="resetFilters()" [disabled]="ObjectKeys(filterList).length == 0">
      <mat-icon>filter_alt_off</mat-icon>
      <span>Supprimer les filtres</span>
    </button>
    <button mat-menu-item (click)="resetLocalConfiguration()">
      <mat-icon>restart_alt</mat-icon>
      <span>Réinitialiser les colonnes</span>
    </button>
  </div>
</mat-menu>
